import * as React from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import { useRelatedRoles } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRelatedRolesContext';
import type { ConsumerPathwayRolePageDataContextType } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRolePageDataContext';
import CareerRoleCard from 'bundles/unified-common/components/CareerRoleCard';
import CareerAcademyModule from 'bundles/unified-common/modules/CareerAcademyModule';

import _t from 'i18n!nls/career-academy';

type Props = {
  pageData: ConsumerPathwayRolePageDataContextType;
};

export const RelatedRolesModuleRenderer = ({ pageData }: Props) => {
  const { relatedCareerRoles } = useRelatedRoles() || {};
  const track = useTracker();

  if (!relatedCareerRoles || !relatedCareerRoles.entities?.length) {
    return null;
  }

  const trackCtaClick = () => {
    track('click_button', {
      button: {
        name: 'career_academy_cta',
        linkName: 'explore_all_roles',
        linkType: 'internal',
        linkURL: '/career-academy',
      },
    });
  };

  return (
    <div data-testid="related-roles-module">
      <CareerAcademyModule
        headline={
          pageData?.careerRoleData?.name
            ? _t('Roles similar to #{roleName}', { roleName: pageData?.careerRoleData?.name })
            : _t('Similar roles')
        }
        collection={relatedCareerRoles}
        cta={{
          text: _t('View all roles'),
          target: '/career-academy',
          variant: 'ghost',
          onClick: trackCtaClick,
        }}
        ProductCardComponent={CareerRoleCard}
        layout="text-top/image-bottom"
        backgroundColor="grey"
        numOfEntriesPerCollection={4}
        defaultMobileRows={4}
        showAllEntries
      />
    </div>
  );
};

export default RelatedRolesModuleRenderer;
